import PropTypes from 'prop-types'

export default function DivBlueBg({ children, className, ...props }) {
  return (
    <div className={`text-left bg-gray-50 bd-gray-200 p-4 ${className ? className :''}`} {...props}>
      {children}
    </div>
  )
}

DivBlueBg.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string
}